import {
  StackPlus, StackMinus, LockSimple, LockSimpleOpen, Copy, Trash, Stack,
  AlignLeft, AlignRight, AlignCenterHorizontal, AlignTop, AlignBottom, AlignCenterVertical,
} from "@phosphor-icons/react";

const ALIGN = [
  { id: "left", Icon: AlignLeft, label: "Align left" },
  { id: "centerH", Icon: AlignCenterHorizontal, label: "Align center" },
  { id: "right", Icon: AlignRight, label: "Align right" },
  { id: "top", Icon: AlignTop, label: "Align top" },
  { id: "middleV", Icon: AlignCenterVertical, label: "Align middle" },
  { id: "bottom", Icon: AlignBottom, label: "Align bottom" },
];

function Action({ onClick, icon: Icon, children, testid, danger }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`w-full flex items-center gap-2 h-10 px-3 rounded-lg text-sm font-medium transition-colors ${
        danger ? "text-red-400 hover:bg-red-500/10" : "text-zinc-200 hover:bg-white/10"
      }`}
    >
      <Icon size={17} /> {children}
    </button>
  );
}

export default function MultiSelectPanel({
  count, grouped, allLocked, onGroup, onUngroup, onLock, onUnlock, onDuplicate, onDelete, onAlign,
}) {
  return (
    <div className="p-4 h-full overflow-y-auto custom-scrollbar" data-testid="multi-select-panel">
      <div className="flex items-center gap-2 mb-1">
        <Stack size={18} weight="fill" className="text-fuchsia-400" />
        <span className="text-sm font-semibold">{count} layers selected</span>
      </div>
      <p className="text-[11px] text-zinc-500 mb-4">Move them together on the canvas, or use the actions below.</p>

      <p className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-semibold mb-2">Align</p>
      <div className="grid grid-cols-6 gap-1 mb-5">
        {ALIGN.map(({ id, Icon, label }) => (
          <button
            key={id}
            onClick={() => onAlign(id)}
            title={label}
            data-testid={`multi-align-${id}`}
            className="h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center text-zinc-300 transition-colors"
          >
            <Icon size={16} />
          </button>
        ))}
      </div>

      <p className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-semibold mb-1">Arrange</p>
      <div className="space-y-0.5 mb-3">
        {grouped ? (
          <Action onClick={onUngroup} icon={StackMinus} testid="multi-ungroup-btn">Ungroup</Action>
        ) : (
          <Action onClick={onGroup} icon={StackPlus} testid="multi-group-btn">Group layers</Action>
        )}
        {allLocked ? (
          <Action onClick={onUnlock} icon={LockSimpleOpen} testid="multi-unlock-btn">Unlock all</Action>
        ) : (
          <Action onClick={onLock} icon={LockSimple} testid="multi-lock-btn">Lock all</Action>
        )}
        <Action onClick={onDuplicate} icon={Copy} testid="multi-duplicate-btn">Duplicate</Action>
        <Action onClick={onDelete} icon={Trash} testid="multi-delete-btn" danger>Delete</Action>
      </div>
    </div>
  );
}
